import { FLOWS_LIST_ACTION_NAMES } from '../../features/flows/redux/flows-list.actions';
import { REPLICATIONS_LIST_ACTION_NAMES } from '../../features/replications/redux/replications-list.actions';
import { Action } from '../redux.types';

import { PROJECT_OVERVIEW_ACTION_NAMES } from './project-overview.actions';
import { ProjectOverviewMainState } from './project-overview.types';

export const projectOverviewMainStateDefaultState = {
  isProjectDeleteModalOpened: false,
  isNewFlowInSidebarShown: false,
  isNewReplicationInSidebarShown: false,
};

export const projectOverviewMainState = (
  state: ProjectOverviewMainState = projectOverviewMainStateDefaultState,
  action: Action,
): ProjectOverviewMainState => {
  switch (action.type) {
    case PROJECT_OVERVIEW_ACTION_NAMES.SHOW_PROJECT_DELETE_MODAL:
      return {
        ...state,
        isProjectDeleteModalOpened: true,
      };

    case PROJECT_OVERVIEW_ACTION_NAMES.HIDE_PROJECT_DELETE_MODAL:
      return {
        ...state,
        isProjectDeleteModalOpened: false,
      };

    case PROJECT_OVERVIEW_ACTION_NAMES.SHOW_ADD_FLOW_IN_SIDEBAR:
      return {
        ...state,
        isNewFlowInSidebarShown: true,
      };

    case FLOWS_LIST_ACTION_NAMES.CREATE_START:
    case PROJECT_OVERVIEW_ACTION_NAMES.HIDE_ADD_FLOW_IN_SIDEBAR:
      return {
        ...state,
        isNewFlowInSidebarShown: false,
      };

    case PROJECT_OVERVIEW_ACTION_NAMES.SHOW_ADD_REPLICATION_IN_SIDEBAR:
      return {
        ...state,
        isNewReplicationInSidebarShown: true,
      };

    case REPLICATIONS_LIST_ACTION_NAMES.CREATE_START:
    case PROJECT_OVERVIEW_ACTION_NAMES.HIDE_ADD_REPLICATION_IN_SIDEBAR:
      return {
        ...state,
        isNewReplicationInSidebarShown: false,
      };

    default:
      return state;
  }
};
